var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M9-9.5a3.379,3.379,0,0,1,2.484,1.016A3.361,3.361,0,0,1,12.5-6.016a3.361,3.361,0,0,1-1.016,2.469A3.361,3.361,0,0,1,9.016-2.531,3.361,3.361,0,0,1,6.547-3.547,3.342,3.342,0,0,1,5.531-6a3.744,3.744,0,0,1,.125-.969A1.757,1.757,0,0,0,6.5-6.75a1.684,1.684,0,0,0,1.234-.516A1.684,1.684,0,0,0,8.25-8.5a1.757,1.757,0,0,0-.219-.844A3.043,3.043,0,0,1,9-9.5Zm8.906,3.031A1.177,1.177,0,0,1,18-6a1.177,1.177,0,0,1-.094.469,10.442,10.442,0,0,1-3.687,4.016A9.507,9.507,0,0,1,9,0,9.519,9.519,0,0,1,5.391-.7,10.139,10.139,0,0,1,2.313-2.641,10.638,10.638,0,0,1,.094-5.531,1.177,1.177,0,0,1,0-6a1.177,1.177,0,0,1,.094-.469,10.442,10.442,0,0,1,3.688-4.016A9.507,9.507,0,0,1,9-12a9.507,9.507,0,0,1,5.219,1.516A10.442,10.442,0,0,1,17.906-6.469ZM9-1.5a8.139,8.139,0,0,0,4.3-1.2A8.691,8.691,0,0,0,16.438-6,8.691,8.691,0,0,0,13.3-9.3,8.139,8.139,0,0,0,9-10.5,8.139,8.139,0,0,0,4.7-9.3,8.691,8.691,0,0,0,1.563-6,8.7,8.7,0,0,0,3.469-3.609,8.5,8.5,0,0,0,6.047-2.047,8.157,8.157,0,0,0,9-1.5Z",
    transform: "translate(0 12)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.20f31fdaf87d7534f69a01c409ac94c6.svg";
export { ForwardRef as ReactComponent };